<form [formGroup]="form" class="pt-4">
  <div class="grid">
    <div class="col-5">
      <div class="p-float-label">
        <input class="w-full" pInputText formControlName="name" />
        <label>{{ 'msg.workspace.settings.schedules.form.label.name' | translate }}</label>
      </div>
    </div>
    <div class="col-5">
      <div class="p-float-label">
        <textarea rows="1" class="w-full" pInputTextarea [autoResize]="true" formControlName="description"></textarea>
        <label>{{ 'msg.workspace.settings.schedules.form.label.description' | translate }}</label>
      </div>
    </div>
    <div class="col-2 text-right">
      <p-button
        icon="pi pi-save"
        pTooltip="{{ 'msg.workspace.settings.schedules.form.tooltip.save' | translate }}"
        tooltipPosition="top"
        [disabled]="!form.valid"
        (click)="onSubmit()"
      ></p-button>
    </div>
  </div>
  <div class="grid mt-1">
    <div class="col-5">
      <div class="flex align-items-center h-full">
        <p-checkbox formControlName="isPublic" binary="true" inputId="isPublicCheckbox" class="mr-2"></p-checkbox>
        <label for="isPublicCheckbox" class="mb-0 cursor-pointer">
          {{ 'msg.workspace.settings.schedules.form.label.is-public' | translate }}
        </label>
      </div>
    </div>
  </div>
</form>
